app.factory('stripe', ['$http','Config','CacheFactory','$rootScope','helper', function($http,Config,CacheFactory,$rootScope,helper) {

	var factoryFns =  {
	  	createToken: function(data,cardNumber,stripe){
			factoryFns.clearError();
	  		helper.showTransLoader();
		  	//then send payment request
        	stripe.createToken(
				  cardNumber
			).then(function(result) {
			  if (result.error) {
			  	helper.hideTransLoader();
                factoryFns.showError(result.error.message);
			  } else {
			  	const customerTokenData = Object.assign({}, data, {token_id:result.token.id});
			    //send request to create a customer
			    fetch('/checkout/create-customer', {
			      method: 'POST',
			      headers: {
			        'Content-Type': 'application/json',
			        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
			      },
			      body: JSON.stringify(customerTokenData)
			    }).then(function(result) {
			    	result.json().then(function(json) {
			    		if (json.error) {
		    				// Show error from server on payment form
							helper.hideTransLoader();
							factoryFns.showError(json.error);
			    		}else{
			    			var customer_id = json.customer_id;
					        factoryFns.createPaymentMethod(customer_id,cardNumber,data,stripe);
			    		}
			    	});
			    });
			  }
			});
	  	},
	  	createPaymentMethod: function(customer_id,cardNumber,data,stripe){

	  		stripe.createPaymentMethod(
				  'card',
				  cardNumber
			).then(function(result) {
			  if (result.error) {
			  		helper.hideTransLoader();
                  	factoryFns.showError(result.error.message);
			  } else {
			  	const paymentIntentTokenData = Object.assign({}, data, {payment_method_id:result.paymentMethod.id,customer_id:customer_id});

			    // Send paymentMethod.id to server
			    fetch('/checkout/complete-payment', {
			      method: 'POST',
			      headers: {
			        'Content-Type': 'application/json',
			        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
			      },
			      body: JSON.stringify(paymentIntentTokenData)
			    }).then(function(result) {
			      // Handle server response (see Step 3)
			      result.json().then(function(json) {

			      	if (json.error) {
	    				// Show error from server on payment form
						helper.hideTransLoader();
						factoryFns.showError(json.error);
		    		}else{
	        			factoryFns.handleServerResponse(json,data,stripe,customer_id);
		    		}

			      })
			    });
			  }
			});
	  	},
	  	handleAction: function(response,data,stripe,customer_id) {
			stripe.handleCardAction(
				response.payment_intent_client_secret
			).then(function(result) {
				if (result.error) {
					// Show error in payment form
					helper.hideTransLoader();
					factoryFns.showError(result.error.message);
				} else {
					const handleActionData = Object.assign({}, data, {payment_intent_id:result.paymentIntent.id,customer_id:customer_id});

					// The card action has been handled
					// The PaymentIntent can be confirmed again on the server
					fetch('/checkout/complete-payment', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
						},
						body: JSON.stringify(handleActionData)
					}).then(function(confirmResult) {
						return confirmResult.json();
					}).then(function(result) {
						if (result.error) {
							// Show error in payment form
							helper.hideTransLoader();
							factoryFns.showError(result.error);
						}else{
							factoryFns.handleServerResponse(result,data,stripe);
						}
				    });
				}
			});
		},
	  	handleServerResponse: function(response,data,stripe,customer_id){
			if (response.error) {
				// Show error from server on payment form
				helper.hideTransLoader();
				factoryFns.showError(response.error.message);
			} else if (response.requires_action) {
				// Use Stripe.js to handle required card action
				factoryFns.handleAction(response,data,stripe,customer_id);
			} else {
				const paymentSuccessData = Object.assign({}, data, {payment_id:response.payment_id});

				// Show success message
				fetch('/checkout/payment-success', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
					},
					body: JSON.stringify(paymentSuccessData)
				}).then(function(result) {
					result.json().then(function(json) {
						$rootScope.$broadcast('saveOrderEvent', {
			                orderID: json.orderID,
			                transID: json.transID
			            });
					});
				});
			}
	  	},
	  	showError: function(error){
	  		var errorElement = document.getElementById('payment-errors');
			errorElement.textContent = error;
	  	},
	  	clearError: function(){
	  		var errorElement = document.getElementById('payment-errors');
			errorElement.textContent = '';
	  	}
	}
	return factoryFns;



}]);